<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">桥梁列表</div>
    </div>
    <div class="modul-content">
      <!-- 查询 -->
      <div class="query-form">
        <el-form :inline="true">
          <el-form-item label="桥梁名称"
            ><el-input
              v-model="bridgeName"
              clearable
              @clear="getBiBridgeBoPage()"
              placeholder="请输入桥梁名称"
            ></el-input
          ></el-form-item>
          <el-form-item
            ><el-button type="primary" @click="getBiBridgeBoPage()"
              >查询</el-button
            ></el-form-item
          >
        </el-form>
        <el-form :inline="true">
          <el-form-item><el-button @click="addClick">新增</el-button></el-form-item>
          <el-form-item><el-button @click="onExport">导出</el-button></el-form-item>
          <el-form-item><el-button @click="show = !show">删除</el-button></el-form-item>
        </el-form>
      </div>
      <div class="bridge-card">
        <div v-for="(item, index) in tableData" :key="index" class="bridge-content">
          <el-carousel>
            <el-carousel-item
              v-for="(item1, index1) in item.scenePictureUrl"
              :key="index1"
            >
              <el-image
                :src="item1"
                :preview-src-list="item.scenePictureUrl"
                fit="cover"
                class="bridge-image"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </el-carousel-item>
          </el-carousel>
          <div class="bridge-info">
            <div class="bridge-name" :title="item.bridgeName">{{ item.bridgeName }}</div>
            <div>
              <span
                @click="xiangqing(item)"
                style="color: #145289; cursor: pointer; margin-right: 5px"
                >详情</span
              >
              <span @click="update(item)" style="color: #145289; cursor: pointer"
                >编辑</span
              >
            </div>
          </div>
          <div
            class="del-icon"
            :style="{ display: show ? 'block' : 'none' }"
            @click="del(item)"
          >
            <i class="el-icon-error"></i>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: center; margin: 20px 0 0">
      <!--描述：分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNum"
        :page-sizes="[8, 24, 48, 120, 200]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 新增桥梁信息 -->
    <el-dialog
      :modal-append-to-body="false"
      :visible.sync="addVisible"
      width="65%"
      @close="cancelDialog()"
      :close-on-click-modal="false"
    >
      <!-- title -->
      <span slot="title">
        <div class="modul-top1">
          <div class="caidan-img">
            <img src="../../../assets/image/caidan.png" alt="菜单" />
          </div>
          <div class="caidan-title">桥梁/查看</div>
        </div>
      </span>
      <qiaoliangadd
        ref="qiaoliangadd"
        @closeDialog="closeDialog"
        @getBiBridgeBoPage="getBiBridgeBoPage"
      >
      </qiaoliangadd>
      <div slot="footer" class="anniu">
        <el-button type="primary" @click="add_sure()">确 定</el-button>
        <el-button @click="cancelDialog()">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 桥梁信息详情 -->
    <el-dialog
      :modal-append-to-body="false"
      :visible.sync="addVisibles"
      width="75%"
      @close="guanbi()"
      :close-on-click-modal="false"
    >
      <!-- title -->
      <span slot="title">
        <div class="modul-top1">
          <div class="caidan-img">
            <img src="../../../assets/image/caidan.png" alt="菜单" />
          </div>
          <div class="caidan-title">桥梁</div>
        </div>
      </span>
      <qiaoliangxiangqing
        :qiaoliangxiangqingData="qiaoliangxiangqingData"
      ></qiaoliangxiangqing>
      <div slot="footer" class="anniu">
        <el-button type="primary" <el-button @click="guanbi()">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qiaoliangadd from './components/qiaoliangAdd.vue';
import qiaoliangxiangqing from './components/qiaoliangxiangqing.vue';
import axios from 'axios';
export default {
  name: 'index',
  components: {
    qiaoliangadd,
    qiaoliangxiangqing
  },
  data() {
    return {
      bridgeName: '',
      tableData: [],
      loading: false,
      // 分页器
      pagination: {
        pageSize: 8,
        pageNum: 1 //当前页数
      },
      total: 0,
      addVisible: false,
      addVisibles: false,
      index: '1',
      show: false,
      qiaoliangxiangqingData: {}
    };
  },
  async mounted() {
    // 获取-桥梁录入信息
    this.getBiBridgeBoPage();
  },
  methods: {
    // 取消按钮操作
    cancelDialog() {
      // 标签栏到第一栏
      this.$refs.qiaoliangadd.tabsIndex = '1';
      // 关闭详情校验
      this.$refs.qiaoliangadd.$refs.xiangqing.ruleForm = {
        bridgeName: '',
        bridgeId: null,
        bridgeUuid: '',
        ascriptionName: '',
        longitude: '',
        latitude: '',
        inspectionCycle: 1,
        inspectionCycleStart: '',
        bridgeModelAddress: '',
        bridgeRotationAmount: '',
        address: '',
        introduce: '',
        curingUtil: '',
        curingUtilUuid: '',
        managementUnit:"",
				warnPhones: '',
				isIot:0,
      };
      // 重置设备配置
      this.$refs.qiaoliangadd.$refs.shebeipeizhi.tableData = [
        {
          bridgeUuid: '',
          equipmentName: '',
          equipmentCode: '',
          sim: '',
          beginWarningValue: '',
          endWarningValue: '',
          equipmentId: '',
          equipmentTypeName: '',
          equipmentTypeUuid: '',
          communicationChannel: '',
          isEnable: false,
          status: 1,
          equipmentAnotherName: ''
        }
      ];
      // 重置照片
      this.$refs.qiaoliangadd.$refs.zhaopian.ruleForm = {
        modelPictureUrl: [],
        scenePictureUrl: [],
        bridgeSidePictureUrl: [],
        bridgeEquipmentTypePictures: [
          {
            equipmentTypePictureUrl: [],
            equipmentTypeUuid: ''
          }
        ],
        bridgePictureUrl: [],
        maybePicture: []
      };
      // 重置设计档案
      this.$refs.qiaoliangadd.$refs.shejidangan.designDocumentUrl = [];
      // 重置检测档案
      this.$refs.qiaoliangadd.$refs.jiancedangan.checkDocumentUrl = [];
      // 重置巡检档案
      this.$refs.qiaoliangadd.$refs.xunjiandangan.inspectionDocumentUrl = [];
      // 重置健康状态
      this.$refs.qiaoliangadd.$refs.jiankangzhuangtai.ruleForm.status = '';
      this.$refs.qiaoliangadd.$refs.jiankangzhuangtai.ruleForm.criteria = '';
      // 关闭弹框
      this.addVisible = false;
      // 获取-桥梁录入信息
      this.getBiBridgeBoPage();
    },
    // 最后一步关闭弹框
    closeDialog() {
      console.log('关闭弹窗');
      this.addVisible = false;
      this.$refs.qiaoliangadd.tabsIndex = '1';
      // 获取-桥梁录入信息
      this.getBiBridgeBoPage();
    },
    // 新增弹框
    addClick() {
      this.addVisible = true;
      // 清空桥梁uuid
      global.bridgeUuid = '';
      // 新增详情
      global.isUpdate = false;
    },
    // 新增桥梁信息
    add_sure() {
      if (this.$refs.qiaoliangadd.tabsIndex == 1) {
        // 子组件详情保存
        this.$refs.qiaoliangadd.$refs.xiangqing.xiangQingBC();
      } else if (this.$refs.qiaoliangadd.tabsIndex == 2) {
        // 子组件设备配置保存
        this.$refs.qiaoliangadd.$refs.shebeipeizhi.sheBeiPeiZhiBC();
      } else if (this.$refs.qiaoliangadd.tabsIndex == 3) {
        // 子组件照片保存
        this.$refs.qiaoliangadd.$refs.zhaopian.zhaoPianBC();
      } else if (this.$refs.qiaoliangadd.tabsIndex == 4) {
        // 子组件设计档案保存
        this.$refs.qiaoliangadd.$refs.shejidangan.sheJiDangAnBC();
      } else if (this.$refs.qiaoliangadd.tabsIndex == 5) {
        // 子组件检测档案保存
        this.$refs.qiaoliangadd.$refs.jiancedangan.jianCeDangAnBC();
      } else if (this.$refs.qiaoliangadd.tabsIndex == 6) {
        // 子组件巡检档案保存
        this.$refs.qiaoliangadd.$refs.xunjiandangan.xunJiandanganDangAnBC();
      } else if (this.$refs.qiaoliangadd.tabsIndex == 7) {
        // 子组件桥梁健康状态保存
        this.$refs.qiaoliangadd.$refs.jiankangzhuangtai.zhuangTaiBC();
      } else if (this.$refs.qiaoliangadd.tabsIndex == 8) {
        // 子组件一桥一档状态保存
        this.$refs.qiaoliangadd.$refs.yiqiaoyidang.yiQiaoYiDangBC();
      } else {
        this.$refs.qiaoliangadd.$refs.monitor.save();
      }
    },
    // 获取-桥梁录入信息
    async getBiBridgeBoPage() {
      let data = {
        bridgeName: this.bridgeName,
        facilityTypeName:"桥梁",
        ...this.pagination
      };
      const res = await this.$api.sendPost('/biBridge/getBiBridgeBoPage', data);
      console.log(res);
      if (res.errcode == 0) {
        if (res.data && res.data.list.length > 0) {
          res.data.list.map((item) => {
            item.scenePictureUrl
              ? (item.scenePictureUrl = item.scenePictureUrl.split(','))
              : (item.scenePictureUrl = '');
          });
          this.tableData = res.data.list
          this.total = res.data.total;
        } else {
          this.tableData = [];
        }
      }
      console.log('qiaoliang', this.tableData);
    },
    // 导出
    onExport() {
      axios({
        method: 'get',
        url: this.$config.host + '/biBridge/exportExcel',
        params: {
          // // equipmentTypeName: '设备类型', //设备类型名称
          // isExportAll: false, //true:导出所有，false:导出当前页 默认:false
          // pageNum: this.pagination.pageNum, //页数 默认:1
          // pageSize: this.pagination.pageSize //条数 默认:10
        },
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((res) => {
          const link = document.createElement('a');
          let blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel'
            // type: "application/pdf;charset=utf-8",  //.pdf
          });
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          link.download = '桥梁录入' + '.xls'; //下载的文件名  注意：加.xls是兼容火狐浏览器
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 修改
    update(row) {
      const obj = JSON.parse(JSON.stringify(row));
      console.log('修改', row);
      // 详情
      let xiangQingForm = {
        bridgeName: obj.bridgeName,
        bridgeId: obj.bridgeId,
        bridgeUuid: obj.bridgeUuid,
        ascriptionName: obj.ascriptionName,
        longitude: obj.longitude,
        latitude: obj.latitude,
        inspectionCycle: obj.inspectionCycle,
        inspectionCycleStart: obj.inspectionCycleStart,
        bridgeModelAddress: obj.bridgeModelAddress,
        bridgeRotationAmount: obj.bridgeRotationAmount,
        address: obj.address,
        introduce: obj.introduce,
        curingUtil: obj.curingUtil,
        curingUtilUuid: obj.curingUtilUuid,
        managementUnit: obj.managementUnit,
        warnPhones: obj.warnPhones,
        isIot:obj.isIot,
      };
      global.bridgeUuid = row.bridgeUuid;
      // 判断是否是修改操作
      global.isUpdate = true;
      this.addVisible = true;
      this.$nextTick(() => {
        // 详情表单赋值
        this.$refs.qiaoliangadd.$refs.xiangqing.ruleForm = xiangQingForm;
        // 设备配置赋值
        this.$refs.qiaoliangadd.$refs.shebeipeizhi.tableData = obj.biEquipmentList.map(
          (item) => {
            return {
              bridgeUuid: item.bridgeUuid,
              equipmentName: item.equipmentName,
              equipmentCode: item.equipmentCode,
              sim: item.sim,
              dtuId: item.dtuId,
              channelCount: item.channelCount,
              beginWarningValue: item.beginWarningValue,
              endWarningValue: item.endWarningValue,
              btnText: true,
              equipmentTypeName: item.equipmentTypeName,
              equipmentTypeUuid: item.equipmentTypeUuid,
              equipmentId: item.equipmentId,
              equipmentUuid: item.equipmentUuid,
              communicationChannel: item.communicationChannel,
              isEnable: item.isEnable ? false : true,
              status: item.status,
              equipmentAnotherName: item.equipmentAnotherName
            };
          }
        );
        // 照片赋值
        this.$refs.qiaoliangadd.$refs.zhaopian.ruleForm = {
          modelPictureUrl: obj.modelPictureUrl
            ? obj.modelPictureUrl.split(',').map((item) => {
                return {
                  url: item
                };
              })
            : [],
          scenePictureUrl: obj.scenePictureUrl
            ? obj.scenePictureUrl.map((item) => {
                return {
                  url: item
                };
              })
            : [],
          bridgeSidePictureUrl: obj.bridgeSidePictureUrl
            ? obj.bridgeSidePictureUrl.split(',').map((item) => {
                return {
                  url: item
                };
              })
            : [],
          bridgeEquipmentTypePictures:
            obj.bridgeEquipmentTypePictures.length > 0
              ? obj.bridgeEquipmentTypePictures.map((item) => {
                  return {
                    equipmentTypePictureUrl: [
                      {
                        url: item.equipmentTypePictureUrl
                      }
                    ],
                    equipmentTypeUuid: item.equipmentTypeUuid
                  };
                })
              : [
                  {
                    equipmentTypePictureUrl: [],
                    equipmentTypeUuid: ''
                  }
                ],
          bridgePictureUrl: obj.bridgePictureUrl
            ? obj.bridgePictureUrl.split(',').map((item) => {
                return {
                  url: item
                };
              })
            : [],
          maybePicture: obj.maybePicture
            ? obj.maybePicture.split(',').map((item) => {
                return {
                  url: item
                };
              })
            : [],
          equipmentTypeUuids: obj.equipmentTypeUuids
            ? obj.equipmentTypeUuids.split(',')
            : []
        };
        const arr = this.$refs.qiaoliangadd.$refs.zhaopian.ruleForm
          .bridgeEquipmentTypePictures;
        if (
          arr[arr.length - 1].equipmentTypeUuid &&
          arr[arr.length - 1].equipmentTypePictureUrl[0].url
        ) {
          arr.push({
            equipmentTypePictureUrl: [],
            equipmentTypeUuid: ''
          });
        }
        console.log(arr);
        // 设计档案赋值
        this.$refs.qiaoliangadd.$refs.jiancedangan.checkDocumentUrl = obj.checkDocumentUrl
          ? obj.checkDocumentUrl.split(',').map((item) => {
              return {
                name: item,
                url: item
              };
            })
          : [];
        // 检测档案赋值
        this.$refs.qiaoliangadd.$refs.shejidangan.designDocumentUrl = obj.designDocumentUrl
          ? obj.designDocumentUrl.split(',').map((item) => {
              return {
                name: item,
                url: item
              };
            })
          : [];
        // 检测档案赋值
        this.$refs.qiaoliangadd.$refs.xunjiandangan.inspectionDocumentUrl = obj.inspectionDocumentUrl
          ? obj.inspectionDocumentUrl.split(',').map((item) => {
              return {
                name: item,
                url: item
              };
            })
          : [];
        // 桥梁健康状态赋值
        this.$refs.qiaoliangadd.$refs.jiankangzhuangtai.ruleForm.status = obj.status;
        this.$refs.qiaoliangadd.$refs.jiankangzhuangtai.ruleForm.criteria = obj.criteria;
        // 一桥一档赋值
        this.$refs.qiaoliangadd.$refs.yiqiaoyidang.ruleForm = {
          bridgeDocument: obj.bridgeDocument
            ? [{ name: obj.bridgeDocument, url: obj.bridgeDocument }]
            : [],
          bridgePicture: obj.bridgePicture ? [{ url: obj.bridgePicture }] : []
        };
        /* 视频监控 */

        this.$refs.qiaoliangadd.$refs.monitor.bridgeUuid = global.bridgeUuid;
        this.$refs.qiaoliangadd.$refs.monitor.getMonitorList();
      });
    },
    // 删除
    del(row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const res = await this.$api.sendGet('/biBridge/delete', {
            bridgeUuid: row.bridgeUuid
          });
          if (res.errcode == 0) {
            this.$message.success(res.errmsg);
            // 获取-桥梁录入信息
            this.getBiBridgeBoPage();
          } else {
            this.$message.error(res.errmsg);
          }
        })
        .catch(() => {
          this.$message.error('已取消操作');
        });
    },
    // 分页器----新每页条数
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      // console.log(val);
      this.getBiBridgeBoPage();
    },
    // 分页器-----新当前页
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      // console.log(val);
      this.getBiBridgeBoPage();
    },
    xiangqing(item) {
      this.qiaoliangxiangqingData = item;
      this.addVisibles = true;
      console.log(item);
    },
    guanbi() {
      this.addVisibles = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  grid-gap: 30px 50px;
  /* 一行放两列、两个auto */
  grid-template-columns: auto auto auto;
  padding: 10px;
}

.grid-item {
  background-color: #fff;
  border: 1px solid #999;
  padding: 20px;
  font-size: 30px;
  text-align: center;
}

.modul-content {
  .bridge-card {
    height: 550px;
    height: 650px;
    overflow: auto;
    display: flex;
    // justify-content: space-between;
    grid-gap: 30px 30px;
    grid-template-columns: auto auto auto;
    padding: 10px 0;
    flex-wrap: wrap;

    .bridge-content {
      height: 550px;
      width: 49%;
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px #f8f8f8;
      border-radius: 4px;
      position: relative;
      border-radius: 4px;
      overflow: hidden;

      .bridge-image {
        width: 100%;
        height: 100%;
      }

      .del-icon {
        position: absolute;
        top: -10px;
        right: -10px;
        z-index: 11;
        border-radius: 50%;
        background-color: #ffffff;

        .el-icon-error {
          font-size: 26px;
          cursor: pointer;
          color: red;
        }
      }

      /deep/ .image-slot {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .bridge-info {
      display: flex;
      justify-content: space-between;
      // line-height: 80px;
      padding: 0 14px;
      align-items: center;
      // box-sizing: border-box;
      font-size: 16px;
      background: #e2e6f4;
      height: 44px;

      .bridge-name {
        text-align: left;
        width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 600;
        color: #000;
      }

      .bridge-operate {
        display: flex;

        :nth-child(1) {
          margin-right: 20px;
        }
      }
    }
  }
}

::v-deep .el-carousel__container {
  height: 500px;
  // margin: 10px 0;
}

::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
  width: 10px;
  height: 10px;
  background: #3079fa;
  border: 1px solid #ffffff;
  border-radius: 50%;
  opacity: 0.5;
}

::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button {
  width: 10px;
  height: 10px;
  background: #ffffff;
  border-radius: 50%;
  opacity: 1;
}
</style>
